
function parseJWT(token) {
    const split = token.split(".")[1];
    const atob = window.atob( split.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(atob);
}

export class JwtToken{
    constructor(token) {
        this.value = token;
        this._parsed = parseJWT(token);
    }

    checkExpired(limit = 600) {
        const exp = parseInt(this._parsed.exp);
        const now = Math.trunc(Date.now() / 1000);
        const delta = exp - now;
        return delta < limit
    }

    get authorities() {
        return this._parsed.authorities || [];
    }
}
